import {
  Modal,
  Grid,
  Button,
  Heading,
  useToastAlert,
} from '@design-systems/canvas-ui'
import { getRfiTagValues } from '../../../common/common'
import { useState } from 'react'
import { CustomTooltip } from 'mvscommoncomponents'
import { FEEDBACK_EMAIL_ID } from '../../../common/commonConstants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLightbulb } from '@fortawesome/free-solid-svg-icons'
import { copyToClipboard } from '../../../common/helper'

const RFI3ReviewPageModal = (props) => {
  const [isOpen, setIsOpen] = useState(true)
  const makeToast = useToastAlert()

  return (
    <Modal
      isOpen={isOpen}
      size="sm"
      onClose={() => setIsOpen(false)}
      headingText={
        <Heading size={5} className="lcm-rfi3-review__heading hc8-fs-350">
          Welcome to the RFI3 Review page
        </Heading>
      }
      data-testid="rfi3-review-modal"
      className="lcm-rfi3-review-modal"
    >
      <div className="lcm-rfi3-review__tip hc8-ph-6x hc8-pt-4x">
        Few Tips! <FontAwesomeIcon icon={faLightbulb} size="lg" />
      </div>
      <p
        dangerouslySetInnerHTML={{
          __html: [getRfiTagValues('rfi3Messages')?.approveRejectMessage],
        }}
        className="lcm-rfi3-review__copy hc8-fs-100 hc8-lh-body hc8-ph-6x hc8-pt-4x hc8-mb-none"
      />
      <p
        dangerouslySetInnerHTML={{
          __html: [getRfiTagValues('rfi3Messages')?.fastrackMessage],
        }}
        className="lcm-rfi3-review__copy hc8-fs-100 hc8-lh-body hc8-ph-6x hc8-pt-2x hc8-mb-none"
      />
      <p className="lcm-rfi3-review__copy hc8-fs-100 hc8-lh-body hc8-ph-6x hc8-pt-2x hc8-mb-none">
        If you face any issues or have any questions, please reach out to the
        MVS team at{' '}
        <CustomTooltip
          title={`Click to copy "${FEEDBACK_EMAIL_ID}"`}
          placement="bottom"
          arrow
          component={
            <span
              className="lcm-rfi3-review__email hc8-clr-brand"
              data-testid="copy-feedback-email"
              onClick={() => copyToClipboard(FEEDBACK_EMAIL_ID, makeToast)}
            >
              {FEEDBACK_EMAIL_ID}
            </span>
          }
        />
      </p>
      {/* Action Buttons */}
      <Grid.Container className="lcm-modal-actions lcm-rfi3-review__actions hc8-ph-6x hc8-pv-4x">
        <Button
          variant="primary"
          size="md"
          onClick={() => {
            setIsOpen(false)
          }}
          data-testid="continue-button"
        >
          Continue
        </Button>
      </Grid.Container>
    </Modal>
  )
}

export default RFI3ReviewPageModal
